import {
  CanActivate,
  CanActivateChild,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  NavigationExtras,
  Routes,
} from "@angular/router";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";

import { RolesService, Roles } from "../../services/roles.service";
import { ErrorType } from "../../error/models/error-type.enum";
import { SessionService } from "@cemex-core/angular-services-v8";

@Injectable()
export class AppGuard implements CanActivate, CanActivateChild {
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return this.validateRoute(childRoute);
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return this.validateRoute(route);
  }

  constructor(private router: Router, private rolesService: RolesService, private sessionService: SessionService) {}

  private validateRoute(route: ActivatedRouteSnapshot): boolean {
    if (!this.sessionService.isLoggedIn) {
      this.router.navigate(["/login"]);
      return false;
    }

    if (!this.hasAccessToPath(route)) {
      this.router.navigate(["invoices-payments", "error"], { fragment: ErrorType.Forbidden } as NavigationExtras);
      return false;
    }

    return true;
  }

  private hasAccessToPath(path: ActivatedRouteSnapshot): boolean {
    const roles = this.rolesService.getAllUserRoles();
    const rolesEnum = Roles;
    const authorized: Roles[] = path.data["authorized"];
    const unauthorized: Roles[] = path.data["unauthorized"];
    const isPublic: boolean = path.data["isPublic"];

    // console.log("Authorized array", authorized);
    // console.log("Unauthorized array", unauthorized);

    if (isPublic) {
      return true;
    }

    if (!authorized || authorized.length === 0) {
      if (isPublic === undefined) {
        console.warn(
          `There's no %cauthorized%c property defined in this route, are you sure you don't need one?
                Routes are secured by default, you need to define an %cisPublic%c boolean in this route if you want it to be public`,
          "color: red",
          "",
          "color: red",
          ""
        );
      }

      return false;
    }

    if (unauthorized && unauthorized.length > 0) {
      return !(
        unauthorized.filter((unauthorizedRole) => roles.find((r) => r.roleCode === rolesEnum[unauthorizedRole]))
          .length > 0
      );
    }

    if (authorized.find((x) => x === Roles.Application) && this.rolesService.isInCurrentApplication()) {
      return true;
    }

    if (
      authorized.find((x) => x === Roles.OrdersProductsApplication) &&
      this.rolesService.isInOrdersProductsApplication()
    ) {
      return true;
    }

    if (authorized.find((x) => x === Roles.ConstruagilApplication) && this.rolesService.isInConstruagilApplication()) {
      return true;
    }

    if (authorized && authorized.length > 0) {
      return (
        authorized.filter((authorizedRole) => roles.find((r) => r.roleCode === rolesEnum[authorizedRole])).length > 0
      );
    }

    return false;
  }
}
